import React, { useEffect } from "react";
import Script from "next/script";

const GoogleTranslateWidget = () => {
  const googleTranslateElementInit = () => {
    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages:
            "en,fr,es,de,id,pt,nl,zh-CN,th,ja,ar,iw,cs,da,fil,it,ru,tr,vi,ko,bg,uk",
        },
        "google_translate_element"
      );
    }
  };

  useEffect(() => {
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  return (
    <>
      {/* Google Translate Dropdown Container */}
      <div id="google_translate_element" />

      {/* Google Translate Script */}
      <Script
        src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        strategy="afterInteractive"
        id="google_translate_script"
      />

      {/* Custom CSS to hide everything except dropdown */}
      <style jsx global>{`
        #google_translate_element {
          z-index: 9999;
          width: 44px;
          height: 44px;
          position: absolute;
          top: 0px;
          left: 0px;
          opacity: 0;
        }
        .goog-te-banner-frame.skiptranslate {
          display: none !important;
        }

        .skiptranslate iframe {
          display: none !important;
        }

        .skiptranslate {
          height: 100%;
        }

        .skiptranslate div {
          height: 100%;
        }

        body {
          top: 0px !important;
        }

        .goog-logo-link {
          margin-top: 6px !important;
          display: flex;
          align-items: center;
        }

        .goog-te-combo {
          /* width: 98%; */
          padding: 4px;
          outline: none;
          border-radius: 8px;
          font-size: 12px;
          cursor: pointer;
        }

        .goog-te-gadget {
          font-weight: 300;
        }

        .goog-te-combo {
          width: 100%;
          height: 100%;
          padding: 4px;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 14px;
          font-family: "Poppins", sans-serif !important;
        }
        #goog-gt-tt {
          display: none !important;
        }
      `}</style>
    </>
  );
};

export default GoogleTranslateWidget;
